__webpack_public_path__ = "http://dev.local:8080/assets/";

import "../scss/application.scss";
import {onLoading} from "./_modules/website";
import {loadPage} from "./_modules/home";
import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import Muuri from 'muuri';
import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse'
var imagesLoaded = require('imagesloaded');


var Packery = require('packery');


document.addEventListener("DOMContentLoaded", () => {
    onLoading();
    loadPage();

    window.Alpine = Alpine
    Alpine.plugin(collapse);
    Alpine.start();

    const gridContainer = document.querySelector('.packery-grid');

    if (gridContainer) {
        document.body.style.opacity = '0';
        imagesLoaded( 'body', function() {
        var grid = new Muuri('.packery-grid', {
            layout: {
                rounding: true,
                fillGaps: true,
            },
            layoutOnResize: 10,
            layoutDuration: 10,
        });
        grid.on('layoutEnd', function () {
            grid.refreshItems();
        });
        grid.refreshItems();
        document.body.style.opacity = null;
        });
    }





    const container = document.querySelector('.scroll-wrapper');
    if (container) container.addEventListener('wheel', function (event) {
        // Prevent the default vertical scrolling
        // Scroll horizontally based on the vertical mouse wheel movement
        container.scrollLeft += event.deltaY; // Use deltaY to scroll horizontally
    });

});